export const Icons = [
  "bi bi-columns",
  "bi bi-command",
  "bi bi-compass-fill",
  "bi bi-compass",
  "bi bi-cone-striped",
  "bi bi-cone",
  "bi bi-controller",
  "bi bi-cookie",
  "bi bi-copy",
  "bi bi-cpu-fill",
  "bi bi-cpu",
  "bi bi-credit-card-2-back-fill",
  "bi bi-credit-card-2-back",
  "bi bi-credit-card-2-front-fill",
  "bi bi-credit-card-2-front",
  "bi bi-credit-card-fill",
  "bi bi-credit-card",
  "bi bi-crop",
  "bi bi-crosshair",
  "bi bi-crosshair2",
  "bi bi-css",
  "bi bi-cup-fill",
  "bi bi-cup-hot-fill",
  "bi bi-cup-hot",
  "bi bi-cup-straw",
  "bi bi-cup",
  "bi bi-currency-bitcoin",
  "bi bi-currency-dollar",
  "bi bi-currency-euro",
  "bi bi-currency-exchange",
  "bi bi-currency-pound",
  "bi bi-currency-rupee",
  "bi bi-currency-yen",
  "bi bi-cursor-fill",
  "bi bi-cursor-text",
  "bi bi-cursor",
  "bi bi-dash-circle-dotted",
  "bi bi-dash-circle-fill",
  "bi bi-dash-circle",
  "bi bi-dash-lg",
  "bi bi-dash-square-dotted",
  "bi bi-dash-square-fill",
  "bi bi-dash-square",
  "bi bi-dash",
  "bi bi-database-add",
  "bi bi-database-check",
  "bi bi-database-dash",
  "bi bi-database-down",
  "bi bi-database-exclamation",
  "bi bi-database-fill-add",
  "bi bi-database-fill-check",
  "bi bi-database-fill-dash",
  "bi bi-database-fill-down",
  "bi bi-database-fill-exclamation",
  "bi bi-database-fill-gear",
  "bi bi-database-fill-lock",
  "bi bi-database-fill-slash",
  "bi bi-database-fill-up",
  "bi bi-database-fill-x",
  "bi bi-database-fill",
  "bi bi-database-gear",
  "bi bi-database-lock",
  "bi bi-database-slash",
  "bi bi-database-up",
  "bi bi-database-x",
  "bi bi-database",
  "bi bi-device-hdd-fill",
  "bi bi-device-hdd",
  "bi bi-device-ssd-fill",
  "bi bi-device-ssd",
  "bi bi-diagram-2-fill",
  "bi bi-diagram-2",
  "bi bi-diagram-3-fill",
  "bi bi-diagram-3",
  "bi bi-diamond-fill",
  "bi bi-diamond-half",
  "bi bi-diamond",
  "bi bi-dice-1-fill",
  "bi bi-dice-1",
  "bi bi-dice-2-fill",
  "bi bi-dice-2",
  "bi bi-dice-3-fill",
  "bi bi-dice-3",
  "bi bi-dice-4-fill",
  "bi bi-dice-4",
  "bi bi-dice-5-fill",
  "bi bi-dice-5",
  "bi bi-dice-6-fill",
  "bi bi-dice-6",
  "bi bi-disc-fill",
  "bi bi-disc",
  "bi bi-discord",
  "bi bi-display-fill",
  "bi bi-display",
  "bi bi-displayport-fill",
  "bi bi-displayport",
  "bi bi-distribute-horizontal",
  "bi bi-distribute-vertical",
  "bi bi-door-closed-fill",
  "bi bi-door-closed",
  "bi bi-door-open-fill",
  "bi bi-door-open",
  "bi bi-dot",
  "bi bi-download",
  "bi bi-dpad-fill",
  "bi bi-dpad",
  "bi bi-dribbble",
  "bi bi-dropbox",
  "bi bi-droplet-fill",
  "bi bi-droplet-half",
  "bi bi-droplet",
  "bi bi-duffle-fill",
  "bi bi-duffle",
  "bi bi-ear-fill",
  "bi bi-ear",
  "bi bi-earbuds",
  "bi bi-easel-fill",
  "bi bi-easel",
  "bi bi-easel2-fill",
  "bi bi-easel2",
  "bi bi-easel3-fill",
  "bi bi-easel3",
  "bi bi-egg-fill",
  "bi bi-egg-fried",
  "bi bi-egg",
  "bi bi-eject-fill",
  "bi bi-eject",
  "bi bi-emoji-angry-fill",
  "bi bi-emoji-angry",
  "bi bi-emoji-astonished-fill",
  "bi bi-emoji-astonished",
  "bi bi-emoji-dizzy-fill",
  "bi bi-emoji-dizzy",
  "bi bi-emoji-expressionless-fill",
  "bi bi-emoji-expressionless",
  "bi bi-emoji-frown-fill",
  "bi bi-emoji-frown",
  "bi bi-emoji-grimace-fill",
  "bi bi-emoji-grimace",
  "bi bi-emoji-grin-fill",
  "bi bi-emoji-grin",
  "bi bi-emoji-heart-eyes-fill",
  "bi bi-emoji-heart-eyes",
  "bi bi-emoji-kiss-fill",
  "bi bi-emoji-kiss",
  "bi bi-emoji-laughing-fill",
  "bi bi-emoji-laughing",
  "bi bi-emoji-neutral-fill",
  "bi bi-emoji-neutral",
  "bi bi-emoji-smile-fill",
  "bi bi-emoji-smile-upside-down-fill",
  "bi bi-emoji-smile-upside-down",
  "bi bi-emoji-smile",
  "bi bi-emoji-sunglasses-fill",
  "bi bi-emoji-sunglasses",
  "bi bi-emoji-surprise-fill",
  "bi bi-emoji-surprise",
  "bi bi-emoji-tear-fill",
  "bi bi-emoji-tear",
  "bi bi-emoji-wink-fill",
  "bi bi-emoji-wink",
  "bi bi-envelope-arrow-down-fill",
  "bi bi-envelope-arrow-down",
  "bi bi-envelope-arrow-up-fill",
  "bi bi-envelope-arrow-up",
  "bi bi-envelope-at-fill",
  "bi bi-envelope-at",
  "bi bi-envelope-check-fill",
  "bi bi-envelope-check",
  "bi bi-envelope-dash-fill",
  "bi bi-envelope-dash",
  "bi bi-envelope-exclamation-fill",
  "bi bi-envelope-exclamation",
  "bi bi-envelope-fill",
  "bi bi-envelope-heart-fill",
  "bi bi-envelope-heart",
  "bi bi-envelope-open-fill",
  "bi bi-envelope-open-heart-fill",
  "bi bi-envelope-open-heart",
  "bi bi-envelope-open",
  "bi bi-envelope-paper-fill",
  "bi bi-envelope-paper-heart-fill",
  "bi bi-envelope-paper-heart",
  "bi bi-envelope-paper",
  "bi bi-envelope-plus-fill",
  "bi bi-envelope-plus",
  "bi bi-envelope-slash-fill",
  "bi bi-envelope-slash",
  "bi bi-envelope-x-fill",
  "bi bi-envelope-x",
  "bi bi-envelope",
  "bi bi-eraser-fill",
  "bi bi-eraser",
  "bi bi-escape",
  "bi bi-ethernet",
  "bi bi-ev-front-fill",
  "bi bi-ev-front",
  "bi bi-ev-station-fill",
  "bi bi-ev-station",
  "bi bi-exclamation-circle-fill",
  "bi bi-exclamation-circle",
  "bi bi-exclamation-diamond-fill",
  "bi bi-exclamation-diamond",
  "bi bi-exclamation-lg",
  "bi bi-exclamation-octagon-fill",
  "bi bi-exclamation-octagon",
  "bi bi-exclamation-square-fill",
  "bi bi-exclamation-square",
  "bi bi-exclamation-triangle-fill",
  "bi bi-exclamation-triangle",
  "bi bi-exclamation",
  "bi bi-exclude",
  "bi bi-explicit-fill",
  "bi bi-explicit",
  "bi bi-exposure",
  "bi bi-eye-fill",
  "bi bi-eye-slash-fill",
  "bi bi-eye-slash",
  "bi bi-eye",
  "bi bi-eyedropper",
  "bi bi-eyeglasses",
  "bi bi-facebook",
  "bi bi-fan",
  "bi bi-fast-forward-btn-fill",
  "bi bi-fast-forward-btn",
  "bi bi-fast-forward-circle-fill",
  "bi bi-fast-forward-circle",
  "bi bi-fast-forward-fill",
  "bi bi-fast-forward",
  "bi bi-feather",
  "bi bi-feather2",
  "bi bi-file-arrow-down-fill",
  "bi bi-file-arrow-down",
  "bi bi-file-arrow-up-fill",
  "bi bi-file-arrow-up",
  "bi bi-file-bar-graph-fill",
  "bi bi-file-bar-graph",
  "bi bi-file-binary-fill",
  "bi bi-file-binary",
  "bi bi-file-break-fill",
  "bi bi-file-break",
  "bi bi-file-check-fill",
  "bi bi-file-check",
  "bi bi-file-code-fill",
  "bi bi-file-code",
  "bi bi-file-diff-fill",
  "bi bi-file-diff",
  "bi bi-file-earmark-arrow-down-fill",
  "bi bi-file-earmark-arrow-down",
  "bi bi-file-earmark-arrow-up-fill",
  "bi bi-file-earmark-arrow-up",
  "bi bi-file-earmark-bar-graph-fill",
  "bi bi-file-earmark-bar-graph",
  "bi bi-file-earmark-binary-fill",
  "bi bi-file-earmark-binary",
  "bi bi-file-earmark-break-fill",
  "bi bi-file-earmark-break",
  "bi bi-file-earmark-check-fill",
  "bi bi-file-earmark-check",
  "bi bi-file-earmark-code-fill",
  "bi bi-file-earmark-code",
  "bi bi-file-earmark-diff-fill",
  "bi bi-file-earmark-diff",
  "bi bi-file-earmark-easel-fill",
  "bi bi-file-earmark-easel",
  "bi bi-file-earmark-excel-fill",
  "bi bi-file-earmark-excel",
  "bi bi-file-earmark-fill",
  "bi bi-file-earmark-font-fill",
  "bi bi-file-earmark-font",
  "bi bi-file-earmark-image-fill",
  "bi bi-file-earmark-image",
  "bi bi-file-earmark-lock-fill",
  "bi bi-file-earmark-lock",
  "bi bi-file-earmark-lock2-fill",
  "bi bi-file-earmark-lock2",
  "bi bi-file-earmark-medical-fill",
  "bi bi-file-earmark-medical",
  "bi bi-file-earmark-minus-fill",
  "bi bi-file-earmark-minus",
  "bi bi-file-earmark-music-fill",
  "bi bi-file-earmark-music",
  "bi bi-file-earmark-pdf-fill",
  "bi bi-file-earmark-pdf",
  "bi bi-file-earmark-person-fill",
  "bi bi-file-earmark-person",
  "bi bi-file-earmark-play-fill",
  "bi bi-file-earmark-play",
  "bi bi-file-earmark-plus-fill",
  "bi bi-file-earmark-plus",
  "bi bi-file-earmark-post-fill",
  "bi bi-file-earmark-post",
  "bi bi-file-earmark-ppt-fill",
  "bi bi-file-earmark-ppt",
  "bi bi-file-earmark-richtext-fill",
  "bi bi-file-earmark-richtext",
  "bi bi-file-earmark-ruled-fill",
  "bi bi-file-earmark-ruled",
  "bi bi-file-earmark-slides-fill",
  "bi bi-file-earmark-slides",
  "bi bi-file-earmark-spreadsheet-fill",
  "bi bi-file-earmark-spreadsheet",
  "bi bi-file-earmark-text-fill",
  "bi bi-file-earmark-text",
  "bi bi-file-earmark-word-fill",
  "bi bi-file-earmark-word",
  "bi bi-file-earmark-x-fill",
  "bi bi-file-earmark-x",
  "bi bi-file-earmark-zip-fill",
  "bi bi-file-earmark-zip",
  "bi bi-file-earmark",
  "bi bi-file-easel-fill",
  "bi bi-file-easel",
  "bi bi-file-excel-fill",
  "bi bi-file-excel",
  "bi bi-file-fill",
  "bi bi-file-font-fill",
  "bi bi-file-font",
  "bi bi-file-image-fill",
  "bi bi-file-image",
  "bi bi-file-lock-fill",
  "bi bi-file-lock",
  "bi bi-file-lock2-fill",
  "bi bi-file-lock2",
  "bi bi-file-medical-fill",
  "bi bi-file-medical",
  "bi bi-file-minus-fill",
  "bi bi-file-minus",
  "bi bi-file-music-fill",
  "bi bi-file-music",
  "bi bi-file-pdf-fill",
  "bi bi-file-pdf",
  "bi bi-file-person-fill",
  "bi bi-file-person",
  "bi bi-file-play-fill",
  "bi bi-file-play",
  "bi bi-file-plus-fill",
  "bi bi-file-plus",
  "bi bi-file-post-fill",
  "bi bi-file-post",
  "bi bi-file-ppt-fill",
  "bi bi-file-ppt",
  "bi bi-file-richtext-fill",
  "bi bi-file-richtext",
  "bi bi-file-ruled-fill",
  "bi bi-file-ruled",
  "bi bi-file-slides-fill",
  "bi bi-file-slides",
  "bi bi-file-spreadsheet-fill",
  "bi bi-file-spreadsheet",
  "bi bi-file-text-fill",
  "bi bi-file-text",
  "bi bi-file-word-fill",
  "bi bi-file-word",
  "bi bi-file-x-fill",
  "bi bi-file-x",
  "bi bi-file-zip-fill",
  "bi bi-file-zip",
  "bi bi-file",
  "bi bi-files-alt",
  "bi bi-files",
  "bi bi-filetype-aac",
  "bi bi-filetype-ai",
  "bi bi-filetype-bmp",
  "bi bi-filetype-cs",
  "bi bi-filetype-css",
  "bi bi-filetype-csv",
  "bi bi-filetype-doc",
  "bi bi-filetype-docx",
  "bi bi-filetype-exe",
  "bi bi-filetype-gif",
  "bi bi-filetype-heic",
  "bi bi-filetype-html",
  "bi bi-filetype-java",
  "bi bi-filetype-jpg",
  "bi bi-filetype-js",
  "bi bi-filetype-json",
  "bi bi-filetype-jsx",
  "bi bi-filetype-key",
  "bi bi-filetype-m4p",
  "bi bi-filetype-md",
  "bi bi-filetype-mdx",
  "bi bi-filetype-mov",
  "bi bi-filetype-mp3",
  "bi bi-filetype-mp4",
  "bi bi-filetype-otf",
  "bi bi-filetype-pdf",
  "bi bi-filetype-php",
  "bi bi-filetype-png",
  "bi bi-filetype-ppt",
  "bi bi-filetype-pptx",
  "bi bi-filetype-psd",
  "bi bi-filetype-py",
  "bi bi-filetype-raw",
  "bi bi-filetype-rb",
  "bi bi-filetype-sass",
  "bi bi-filetype-scss",
  "bi bi-filetype-sh",
  "bi bi-filetype-sql",
  "bi bi-filetype-svg",
  "bi bi-filetype-tiff",
  "bi bi-filetype-tsx",
  "bi bi-filetype-ttf",
  "bi bi-filetype-txt",
  "bi bi-filetype-wav",
  "bi bi-filetype-woff",
  "bi bi-filetype-xls",
  "bi bi-filetype-xlsx",
  "bi bi-filetype-xml",
  "bi bi-filetype-yml",
  "bi bi-film",
  "bi bi-filter-circle-fill",
  "bi bi-filter-circle",
  "bi bi-filter-left",
  "bi bi-filter-right",
  "bi bi-filter-square-fill",
  "bi bi-filter-square",
  "bi bi-filter",
  "bi bi-fingerprint",
  "bi bi-fire",
  "bi bi-flag-fill",
  "bi bi-flag",
  "bi bi-flask-fill",
  "bi bi-flask-florence-fill",
  "bi bi-flask-florence",
  "bi bi-flask",
  "bi bi-floppy-fill",
  "bi bi-floppy",
  "bi bi-floppy2-fill",
  "bi bi-floppy2",
  "bi bi-flower1",
  "bi bi-flower2",
  "bi bi-flower3",
  "bi bi-folder-check",
  "bi bi-folder-fill",
  "bi bi-folder-minus",
  "bi bi-folder-plus",
  "bi bi-folder-symlink-fill",
  "bi bi-folder-symlink",
  "bi bi-folder-x",
  "bi bi-folder",
  "bi bi-folder2-open",
  "bi bi-folder2",
  "bi bi-fonts/",
  "bi bi-fonts",
  "bi bi-fork-knife",
  "bi bi-forward-fill",
  "bi bi-forward",
  "bi bi-front",
  "bi bi-fuel-pump-diesel-fill",
  "bi bi-fuel-pump-diesel",
  "bi bi-fuel-pump-fill",
  "bi bi-fuel-pump",
  "bi bi-fullscreen-exit",
  "bi bi-fullscreen",
  "bi bi-funnel-fill",
  "bi bi-funnel",
  "bi bi-gear-fill",
  "bi bi-gear-wide-connected",
  "bi bi-gear-wide",
  "bi bi-gear",
  "bi bi-gem",
  "bi bi-gender-ambiguous",
  "bi bi-gender-female",
  "bi bi-gender-male",
  "bi bi-gender-neuter",
  "bi bi-gender-trans",
  "bi bi-geo-alt-fill",
  "bi bi-geo-alt",
  "bi bi-geo-fill",
  "bi bi-geo",
  "bi bi-gift-fill",
  "bi bi-gift",
  "bi bi-git",
  "bi bi-github",
  "bi bi-gitlab",
  "bi bi-globe-americas-fill",
  "bi bi-globe-americas",
  "bi bi-globe-asia-australia-fill",
  "bi bi-globe-asia-australia",
  "bi bi-globe-central-south-asia-fill",
  "bi bi-globe-central-south-asia",
  "bi bi-globe-europe-africa-fill",
  "bi bi-globe-europe-africa",
  "bi bi-globe",
  "bi bi-globe2",
  "bi bi-google-play",
  "bi bi-google",
  "bi bi-gpu-card",
  "bi bi-graph-down-arrow",
  "bi bi-graph-down",
  "bi bi-graph-up-arrow",
  "bi bi-graph-up",
  "bi bi-grid-1x2-fill",
  "bi bi-grid-1x2",
  "bi bi-grid-3x2-gap-fill",
  "bi bi-grid-3x2-gap",
  "bi bi-grid-3x2",
  "bi bi-grid-3x3-gap-fill",
  "bi bi-grid-3x3-gap",
  "bi bi-grid-3x3",
  "bi bi-grid-fill",
  "bi bi-grid",
  "bi bi-grip-horizontal",
  "bi bi-grip-vertical",
  "bi bi-h-circle-fill",
  "bi bi-h-circle",
  "bi bi-h-square-fill",
  "bi bi-h-square",
  "bi bi-hammer",
  "bi bi-hand-index-fill",
  "bi bi-hand-index-thumb-fill",
  "bi bi-hand-index-thumb",
  "bi bi-hand-index",
  "bi bi-hand-thumbs-down-fill",
  "bi bi-hand-thumbs-down",
  "bi bi-hand-thumbs-up-fill",
  "bi bi-hand-thumbs-up",
  "bi bi-handbag-fill",
  "bi bi-handbag",
  "bi bi-hash",
  "bi bi-hdd-fill",
  "bi bi-hdd-network-fill",
  "bi bi-hdd-network",
  "bi bi-hdd-rack-fill",
  "bi bi-hdd-rack",
  "bi bi-hdd-stack-fill",
  "bi bi-hdd-stack",
  "bi bi-hdd",
  "bi bi-hdmi-fill",
  "bi bi-hdmi",
  "bi bi-headphones",
  "bi bi-headset-vr",
  "bi bi-headset",
  "bi bi-heart-arrow",
  "bi bi-heart-fill",
  "bi bi-heart-half",
  "bi bi-heart-pulse-fill",
  "bi bi-heart-pulse",
  "bi bi-heart",
  "bi bi-heartbreak-fill",
  "bi bi-heartbreak",
  "bi bi-hearts",
  "bi bi-heptagon-fill",
  "bi bi-heptagon-half",
  "bi bi-heptagon",
  "bi bi-hexagon-fill",
  "bi bi-hexagon-half",
  "bi bi-hexagon",
  "bi bi-highlighter",
  "bi bi-highlights",
  "bi bi-hospital-fill",
  "bi bi-hospital",
  "bi bi-hourglass-bottom",
  "bi bi-hourglass-split",
  "bi bi-hourglass-top",
  "bi bi-hourglass",
  "bi bi-house-add-fill",
  "bi bi-house-add",
  "bi bi-house-check-fill",
  "bi bi-house-check",
  "bi bi-house-dash-fill",
  "bi bi-house-dash",
  "bi bi-house-door-fill",
  "bi bi-house-door",
  "bi bi-house-down-fill",
  "bi bi-house-down",
  "bi bi-house-exclamation-fill",
  "bi bi-house-exclamation",
  "bi bi-house-fill",
  "bi bi-house-gear-fill",
  "bi bi-house-gear",
  "bi bi-house-heart-fill",
  "bi bi-house-heart",
  "bi bi-house-lock-fill",
  "bi bi-house-lock",
  "bi bi-house-slash-fill",
  "bi bi-house-slash",
  "bi bi-house-up-fill",
  "bi bi-house-up",
  "bi bi-house-x-fill",
  "bi bi-house-x",
  "bi bi-house",
  "bi bi-houses-fill",
  "bi bi-houses",
  "bi bi-hr",
  "bi bi-hurricane",
  "bi bi-hypnotize",
  "bi bi-image-alt",
  "bi bi-image-fill",
  "bi bi-image",
  "bi bi-images",
  "bi bi-inbox-fill",
  "bi bi-inbox",
  "bi bi-inboxes-fill",
  "bi bi-inboxes",
  "bi bi-incognito",
  "bi bi-indent",
  "bi bi-infinity",
  "bi bi-info-circle-fill",
  "bi bi-info-circle",
  "bi bi-info-lg",
  "bi bi-info-square-fill",
  "bi bi-info-square",
  "bi bi-info",
  "bi bi-input-cursor-text",
  "bi bi-input-cursor",
  "bi bi-instagram",
  "bi bi-intersect",
  "bi bi-javascript",
  "bi bi-journal-album",
  "bi bi-journal-arrow-down",
  "bi bi-journal-arrow-up",
  "bi bi-journal-bookmark-fill",
  "bi bi-journal-bookmark",
  "bi bi-journal-check",
  "bi bi-journal-code",
  "bi bi-journal-medical",
  "bi bi-journal-minus",
  "bi bi-journal-plus",
  "bi bi-journal-richtext",
  "bi bi-journal-text",
  "bi bi-journal-x",
  "bi bi-journal",
  "bi bi-journals",
  "bi bi-joystick",
  "bi bi-justify-left",
  "bi bi-justify-right",
  "bi bi-justify",
  "bi bi-kanban-fill",
  "bi bi-kanban",
  "bi bi-key-fill",
  "bi bi-key",
  "bi bi-keyboard-fill",
  "bi bi-keyboard",
  "bi bi-ladder",
  "bi bi-lamp-fill",
  "bi bi-lamp",
  "bi bi-laptop-fill",
  "bi bi-laptop",
  "bi bi-layer-backward",
  "bi bi-layer-forward",
  "bi bi-layers-fill",
  "bi bi-layers-half",
  "bi bi-layers",
  "bi bi-layout-sidebar-inset-reverse",
  "bi bi-layout-sidebar-inset",
  "bi bi-layout-sidebar-reverse",
  "bi bi-layout-sidebar",
  "bi bi-layout-split",
  "bi bi-layout-text-sidebar-reverse",
  "bi bi-layout-text-sidebar",
  "bi bi-layout-text-window-reverse",
  "bi bi-layout-text-window",
  "bi bi-layout-three-columns",
  "bi bi-layout-wtf",
  "bi bi-leaf-fill",
  "bi bi-leaf",
  "bi bi-life-preserver",
  "bi bi-lightbulb-fill",
  "bi bi-lightbulb-off-fill",
  "bi bi-lightbulb-off",
  "bi bi-lightbulb",
  "bi bi-lightning-charge-fill",
  "bi bi-lightning-charge",
  "bi bi-lightning-fill",
  "bi bi-lightning",
  "bi bi-line",
  "bi bi-link-45deg",
  "bi bi-link",
  "bi bi-linkedin",
  "bi bi-list-check",
  "bi bi-list-columns-reverse",
  "bi bi-list-columns",
  "bi bi-list-nested",
  "bi bi-list-ol",
  "bi bi-list-stars",
  "bi bi-list-task",
  "bi bi-list-ul",
  "bi bi-list",
  "bi bi-list.txt",
  "bi bi-lock-fill",
  "bi bi-lock",
  "bi bi-luggage-fill",
  "bi bi-luggage",
  "bi bi-lungs-fill",
  "bi bi-lungs",
  "bi bi-magic",
  "bi bi-magnet-fill",
  "bi bi-magnet",
  "bi bi-mailbox-flag",
  "bi bi-mailbox",
  "bi bi-mailbox2-flag",
  "bi bi-mailbox2",
  "bi bi-map-fill",
  "bi bi-map",
  "bi bi-markdown-fill",
  "bi bi-markdown",
  "bi bi-marker-tip",
  "bi bi-mask",
  "bi bi-mastodon",
  "bi bi-measuring-cup-fill",
  "bi bi-measuring-cup",
  "bi bi-medium",
  "bi bi-megaphone-fill",
  "bi bi-megaphone",
  "bi bi-memory",
  "bi bi-menu-app-fill",
  "bi bi-menu-app",
  "bi bi-menu-button-fill",
  "bi bi-menu-button-wide-fill",
  "bi bi-menu-button-wide",
  "bi bi-menu-button",
  "bi bi-menu-down",
  "bi bi-menu-up",
  "bi bi-messenger",
  "bi bi-meta",
  "bi bi-mic-fill",
  "bi bi-mic-mute-fill",
  "bi bi-mic-mute",
  "bi bi-mic",
  "bi bi-microsoft-teams",
  "bi bi-microsoft",
  "bi bi-minecart-loaded",
  "bi bi-minecart",
  "bi bi-modem-fill",
  "bi bi-modem",
  "bi bi-moisture",
  "bi bi-moon-fill",
  "bi bi-moon-stars-fill",
  "bi bi-moon-stars",
  "bi bi-moon",
  "bi bi-mortarboard-fill",
  "bi bi-mortarboard",
  "bi bi-motherboard-fill",
  "bi bi-motherboard",
  "bi bi-mouse-fill",
  "bi bi-mouse",
  "bi bi-mouse2-fill",
  "bi bi-mouse2",
  "bi bi-mouse3-fill",
  "bi bi-mouse3",
  "bi bi-music-note-beamed",
  "bi bi-music-note-list",
  "bi bi-music-note",
  "bi bi-music-player-fill",
  "bi bi-music-player",
  "bi bi-newspaper",
  "bi bi-nintendo-switch",
  "bi bi-node-minus-fill",
  "bi bi-node-minus",
  "bi bi-node-plus-fill",
  "bi bi-node-plus",
  "bi bi-noise-reduction",
  "bi bi-nut-fill",
  "bi bi-nut",
  "bi bi-nvidia",
  "bi bi-nvme-fill",
  "bi bi-nvme",
  "bi bi-octagon-fill",
  "bi bi-octagon-half",
  "bi bi-octagon",
  "bi bi-openai",
  "bi bi-opencollective",
  "bi bi-optical-audio-fill",
  "bi bi-optical-audio",
  "bi bi-option",
  "bi bi-outlet",
  "bi bi-p-circle-fill",
  "bi bi-p-circle",
  "bi bi-p-square-fill",
  "bi bi-p-square",
  "bi bi-paint-bucket",
  "bi bi-palette-fill",
  "bi bi-palette",
  "bi bi-palette2",
  "bi bi-paperclip",
  "bi bi-paragraph",
  "bi bi-pass-fill",
  "bi bi-pass",
  "bi bi-passport-fill",
  "bi bi-passport",
  "bi bi-patch-check-fill",
  "bi bi-patch-check",
  "bi bi-patch-exclamation-fill",
  "bi bi-patch-exclamation",
  "bi bi-patch-minus-fill",
  "bi bi-patch-minus",
  "bi bi-patch-plus-fill",
  "bi bi-patch-plus",
  "bi bi-patch-question-fill",
  "bi bi-patch-question",
  "bi bi-pause-btn-fill",
  "bi bi-pause-btn",
  "bi bi-pause-circle-fill",
  "bi bi-pause-circle",
  "bi bi-pause-fill",
  "bi bi-pause",
  "bi bi-paypal",
  "bi bi-pc-display-horizontal",
  "bi bi-pc-display",
  "bi bi-pc-horizontal",
  "bi bi-pc",
  "bi bi-pci-card-network",
  "bi bi-pci-card-sound",
  "bi bi-pci-card",
  "bi bi-peace-fill",
  "bi bi-peace",
  "bi bi-pen-fill",
  "bi bi-pen",
  "bi bi-pencil-fill",
  "bi bi-pencil-square",
  "bi bi-pencil",
  "bi bi-pentagon-fill",
  "bi bi-pentagon-half",
  "bi bi-pentagon",
  "bi bi-people-fill",
  "bi bi-people",
  "bi bi-percent",
  "bi bi-perplexity",
  "bi bi-person-add",
  "bi bi-person-arms-up",
  "bi bi-person-badge-fill",
  "bi bi-person-badge",
  "bi bi-person-bounding-box",
  "bi bi-person-check-fill",
  "bi bi-person-check",
  "bi bi-person-circle",
  "bi bi-person-dash-fill",
  "bi bi-person-dash",
  "bi bi-person-down",
  "bi bi-person-exclamation",
  "bi bi-person-fill-add",
  "bi bi-person-fill-check",
  "bi bi-person-fill-dash",
  "bi bi-person-fill-down",
  "bi bi-person-fill-exclamation",
  "bi bi-person-fill-gear",
  "bi bi-person-fill-lock",
  "bi bi-person-fill-slash",
  "bi bi-person-fill-up",
  "bi bi-person-fill-x",
  "bi bi-person-fill",
  "bi bi-person-gear",
  "bi bi-person-heart",
  "bi bi-person-hearts",
  "bi bi-person-lines-fill",
  "bi bi-person-lock",
  "bi bi-person-plus-fill",
  "bi bi-person-plus",
  "bi bi-person-raised-hand",
  "bi bi-person-rolodex",
  "bi bi-person-slash",
  "bi bi-person-square",
  "bi bi-person-standing-dress",
  "bi bi-person-standing",
  "bi bi-person-up",
  "bi bi-person-vcard-fill",
  "bi bi-person-vcard",
  "bi bi-person-video",
  "bi bi-person-video2",
  "bi bi-person-video3",
  "bi bi-person-walking",
  "bi bi-person-wheelchair",
  "bi bi-person-workspace",
  "bi bi-person-x-fill",
  "bi bi-person-x",
  "bi bi-person",
  "bi bi-phone-fill",
  "bi bi-phone-flip",
  "bi bi-phone-landscape-fill",
  "bi bi-phone-landscape",
  "bi bi-phone-vibrate-fill",
  "bi bi-phone-vibrate",
  "bi bi-phone",
  "bi bi-pie-chart-fill",
  "bi bi-pie-chart",
  "bi bi-piggy-bank-fill",
  "bi bi-piggy-bank",
  "bi bi-pin-angle-fill",
  "bi bi-pin-angle",
  "bi bi-pin-fill",
  "bi bi-pin-map-fill",
  "bi bi-pin-map",
  "bi bi-pin",
  "bi bi-pinterest",
  "bi bi-pip-fill",
  "bi bi-pip",
  "bi bi-play-btn-fill",
  "bi bi-play-btn",
  "bi bi-play-circle-fill",
  "bi bi-play-circle",
  "bi bi-play-fill",
  "bi bi-play",
  "bi bi-playstation",
  "bi bi-plug-fill",
  "bi bi-plug",
  "bi bi-plugin",
  "bi bi-plus-circle-dotted",
  "bi bi-plus-circle-fill",
  "bi bi-plus-circle",
  "bi bi-plus-lg",
  "bi bi-plus-slash-minus",
  "bi bi-plus-square-dotted",
  "bi bi-plus-square-fill",
  "bi bi-plus-square",
  "bi bi-plus",
  "bi bi-postage-fill",
  "bi bi-postage-heart-fill",
  "bi bi-postage-heart",
  "bi bi-postage",
  "bi bi-postcard-fill",
  "bi bi-postcard-heart-fill",
  "bi bi-postcard-heart",
  "bi bi-postcard",
  "bi bi-power",
  "bi bi-prescription",
  "bi bi-prescription2",
  "bi bi-printer-fill",
  "bi bi-printer",
  "bi bi-projector-fill",
  "bi bi-projector",
  "bi bi-puzzle-fill",
  "bi bi-puzzle",
  "bi bi-qr-code-scan",
  "bi bi-qr-code",
  "bi bi-question-circle-fill",
  "bi bi-question-circle",
  "bi bi-question-diamond-fill",
  "bi bi-question-diamond",
  "bi bi-question-lg",
  "bi bi-question-octagon-fill",
  "bi bi-question-octagon",
  "bi bi-question-square-fill",
  "bi bi-question-square",
  "bi bi-question",
  "bi bi-quora",
  "bi bi-quote",
  "bi bi-r-circle-fill",
  "bi bi-r-circle",
  "bi bi-r-square-fill",
  "bi bi-r-square",
  "bi bi-radar",
  "bi bi-radioactive",
  "bi bi-rainbow",
  "bi bi-receipt-cutoff",
  "bi bi-receipt",
  "bi bi-reception-0",
  "bi bi-reception-1",
  "bi bi-reception-2",
  "bi bi-reception-3",
  "bi bi-reception-4",
  "bi bi-record-btn-fill",
  "bi bi-record-btn",
  "bi bi-record-circle-fill",
  "bi bi-record-circle",
  "bi bi-record-fill",
  "bi bi-record",
  "bi bi-record2-fill",
  "bi bi-record2",
  "bi bi-recycle",
  "bi bi-reddit",
  "bi bi-regex",
  "bi bi-repeat-1",
  "bi bi-repeat",
  "bi bi-reply-all-fill",
  "bi bi-reply-all",
  "bi bi-reply-fill",
  "bi bi-reply",
  "bi bi-rewind-btn-fill",
  "bi bi-rewind-btn",
  "bi bi-rewind-circle-fill",
  "bi bi-rewind-circle",
  "bi bi-rewind-fill",
  "bi bi-rewind",
  "bi bi-robot",
  "bi bi-rocket-fill",
  "bi bi-rocket-takeoff-fill",
  "bi bi-rocket-takeoff",
  "bi bi-rocket",
  "bi bi-router-fill",
  "bi bi-router",
  "bi bi-rss-fill",
  "bi bi-rss",
  "bi bi-rulers",
  "bi bi-safe-fill",
  "bi bi-safe",
  "bi bi-safe2-fill",
  "bi bi-safe2",
  "bi bi-save-fill",
  "bi bi-save",
  "bi bi-save2-fill",
  "bi bi-save2",
  "bi bi-scissors",
  "bi bi-scooter",
  "bi bi-screwdriver",
  "bi bi-sd-card-fill",
  "bi bi-sd-card",
  "bi bi-search-heart-fill",
  "bi bi-search-heart",
  "bi bi-search",
  "bi bi-segmented-nav",
  "bi bi-send-arrow-down-fill",
  "bi bi-send-arrow-down",
  "bi bi-send-arrow-up-fill",
  "bi bi-send-arrow-up",
  "bi bi-send-check-fill",
  "bi bi-send-check",
  "bi bi-send-dash-fill",
  "bi bi-send-dash",
  "bi bi-send-exclamation-fill",
  "bi bi-send-exclamation",
  "bi bi-send-fill",
  "bi bi-send-plus-fill",
  "bi bi-send-plus",
  "bi bi-send-slash-fill",
  "bi bi-send-slash",
  "bi bi-send-x-fill",
  "bi bi-send-x",
  "bi bi-send",
  "bi bi-server",
  "bi bi-shadows",
  "bi bi-share-fill",
  "bi bi-share",
  "bi bi-shield-check",
  "bi bi-shield-exclamation",
  "bi bi-shield-fill-check",
  "bi bi-shield-fill-exclamation",
  "bi bi-shield-fill-minus",
  "bi bi-shield-fill-plus",
  "bi bi-shield-fill-x",
  "bi bi-shield-fill",
  "bi bi-shield-lock-fill",
  "bi bi-shield-lock",
  "bi bi-shield-minus",
  "bi bi-shield-plus",
  "bi bi-shield-shaded",
  "bi bi-shield-slash-fill",
  "bi bi-shield-slash",
  "bi bi-shield-x",
  "bi bi-shield",
  "bi bi-shift-fill",
  "bi bi-shift",
  "bi bi-shop-window",
  "bi bi-shop",
  "bi bi-shuffle",
  "bi bi-sign-dead-end-fill",
  "bi bi-sign-dead-end",
  "bi bi-sign-do-not-enter-fill",
  "bi bi-sign-do-not-enter",
  "bi bi-sign-intersection-fill",
  "bi bi-sign-intersection-side-fill",
  "bi bi-sign-intersection-side",
  "bi bi-sign-intersection-t-fill",
  "bi bi-sign-intersection-t",
  "bi bi-sign-intersection-y-fill",
  "bi bi-sign-intersection-y",
  "bi bi-sign-intersection",
  "bi bi-sign-merge-left-fill",
  "bi bi-sign-merge-left",
  "bi bi-sign-merge-right-fill",
  "bi bi-sign-merge-right",
  "bi bi-sign-no-left-turn-fill",
  "bi bi-sign-no-left-turn",
  "bi bi-sign-no-parking-fill",
  "bi bi-sign-no-parking",
  "bi bi-sign-no-right-turn-fill",
  "bi bi-sign-no-right-turn",
  "bi bi-sign-railroad-fill",
  "bi bi-sign-railroad",
  "bi bi-sign-stop-fill",
  "bi bi-sign-stop-lights-fill",
  "bi bi-sign-stop-lights",
  "bi bi-sign-stop",
  "bi bi-sign-turn-left-fill",
  "bi bi-sign-turn-left",
  "bi bi-sign-turn-right-fill",
  "bi bi-sign-turn-right",
  "bi bi-sign-turn-slight-left-fill",
  "bi bi-sign-turn-slight-left",
  "bi bi-sign-turn-slight-right-fill",
  "bi bi-sign-turn-slight-right",
  "bi bi-sign-yield-fill",
  "bi bi-sign-yield",
  "bi bi-signal",
  "bi bi-signpost-2-fill",
  "bi bi-signpost-2",
  "bi bi-signpost-fill",
  "bi bi-signpost-split-fill",
  "bi bi-signpost-split",
  "bi bi-signpost",
  "bi bi-sim-fill",
  "bi bi-sim-slash-fill",
  "bi bi-sim-slash",
  "bi bi-sim",
  "bi bi-sina-weibo",
  "bi bi-skip-backward-btn-fill",
  "bi bi-skip-backward-btn",
  "bi bi-skip-backward-circle-fill",
  "bi bi-skip-backward-circle",
  "bi bi-skip-backward-fill",
  "bi bi-skip-backward",
  "bi bi-skip-end-btn-fill",
  "bi bi-skip-end-btn",
  "bi bi-skip-end-circle-fill",
  "bi bi-skip-end-circle",
  "bi bi-skip-end-fill",
  "bi bi-skip-end",
  "bi bi-skip-forward-btn-fill",
  "bi bi-skip-forward-btn",
  "bi bi-skip-forward-circle-fill",
  "bi bi-skip-forward-circle",
  "bi bi-skip-forward-fill",
  "bi bi-skip-forward",
  "bi bi-skip-start-btn-fill",
  "bi bi-skip-start-btn",
  "bi bi-skip-start-circle-fill",
  "bi bi-skip-start-circle",
  "bi bi-skip-start-fill",
  "bi bi-skip-start",
  "bi bi-skype",
  "bi bi-slack",
  "bi bi-slash-circle-fill",
  "bi bi-slash-circle",
  "bi bi-slash-lg",
  "bi bi-slash-square-fill",
  "bi bi-slash-square",
  "bi bi-slash",
  "bi bi-sliders",
  "bi bi-sliders2-vertical",
  "bi bi-sliders2",
  "bi bi-smartwatch",
  "bi bi-snapchat",
  "bi bi-snow",
  "bi bi-snow2",
  "bi bi-snow3",
  "bi bi-sort-alpha-down-alt",
  "bi bi-sort-alpha-down",
  "bi bi-sort-alpha-up-alt",
  "bi bi-sort-alpha-up",
  "bi bi-sort-down-alt",
  "bi bi-sort-down",
  "bi bi-sort-numeric-down-alt",
  "bi bi-sort-numeric-down",
  "bi bi-sort-numeric-up-alt",
  "bi bi-sort-numeric-up",
  "bi bi-sort-up-alt",
  "bi bi-sort-up",
  "bi bi-soundwave",
  "bi bi-sourceforge",
  "bi bi-speaker-fill",
  "bi bi-speaker",
  "bi bi-speedometer",
  "bi bi-speedometer2",
  "bi bi-spellcheck",
  "bi bi-spotify",
  "bi bi-square-fill",
  "bi bi-square-half",
  "bi bi-square",
  "bi bi-stack-overflow",
  "bi bi-stack",
  "bi bi-star-fill",
  "bi bi-star-half",
  "bi bi-star",
  "bi bi-stars",
  "bi bi-steam",
  "bi bi-stickies-fill",
  "bi bi-stickies",
  "bi bi-sticky-fill",
  "bi bi-sticky",
  "bi bi-stop-btn-fill",
  "bi bi-stop-btn",
  "bi bi-stop-circle-fill",
  "bi bi-stop-circle",
  "bi bi-stop-fill",
  "bi bi-stop",
  "bi bi-stoplights-fill",
  "bi bi-stoplights",
  "bi bi-stopwatch-fill",
  "bi bi-stopwatch",
  "bi bi-strava",
  "bi bi-stripe",
  "bi bi-subscript",
  "bi bi-substack",
  "bi bi-subtract",
  "bi bi-suit-club-fill",
  "bi bi-suit-club",
  "bi bi-suit-diamond-fill",
  "bi bi-suit-diamond",
  "bi bi-suit-heart-fill",
  "bi bi-suit-heart",
  "bi bi-suit-spade-fill",
  "bi bi-suit-spade",
  "bi bi-suitcase-fill",
  "bi bi-suitcase-lg-fill",
  "bi bi-suitcase-lg",
  "bi bi-suitcase",
  "bi bi-suitcase2-fill",
  "bi bi-suitcase2",
  "bi bi-sun-fill",
  "bi bi-sun",
  "bi bi-sunglasses",
  "bi bi-sunrise-fill",
  "bi bi-sunrise",
  "bi bi-sunset-fill",
  "bi bi-sunset",
  "bi bi-superscript",
  "bi bi-symmetry-horizontal",
  "bi bi-symmetry-vertical",
  "bi bi-table",
  "bi bi-tablet-fill",
  "bi bi-tablet-landscape-fill",
  "bi bi-tablet-landscape",
  "bi bi-tablet",
  "bi bi-tag-fill",
  "bi bi-tag",
  "bi bi-tags-fill",
  "bi bi-tags",
  "bi bi-taxi-front-fill",
  "bi bi-taxi-front",
  "bi bi-telegram",
  "bi bi-telephone-fill",
  "bi bi-telephone-forward-fill",
  "bi bi-telephone-forward",
  "bi bi-telephone-inbound-fill",
  "bi bi-telephone-inbound",
  "bi bi-telephone-minus-fill",
  "bi bi-telephone-minus",
  "bi bi-telephone-outbound-fill",
  "bi bi-telephone-outbound",
  "bi bi-telephone-plus-fill",
  "bi bi-telephone-plus",
  "bi bi-telephone-x-fill",
  "bi bi-telephone-x",
  "bi bi-telephone",
  "bi bi-window-dock",
  "bi bi-window-fullscreen",
  "bi bi-window-plus",
  "bi bi-window-sidebar",
  "bi bi-window-split",
  "bi bi-window-stack",
  "bi bi-window-x",
  "bi bi-window",
  "bi bi-windows",
  "bi bi-wordpress",
  "bi bi-wrench-adjustable-circle-fill",
  "bi bi-wrench-adjustable-circle",
  "bi bi-wrench-adjustable",
  "bi bi-wrench",
  "bi bi-x-circle-fill",
  "bi bi-x-circle",
  "bi bi-x-diamond-fill",
  "bi bi-x-diamond",
  "bi bi-x-lg",
  "bi bi-x-octagon-fill",
  "bi bi-x-octagon",
  "bi bi-x-square-fill",
  "bi bi-x-square",
  "bi bi-x",
  "bi bi-xbox",
  "bi bi-yelp",
  "bi bi-yin-yang",
  "bi bi-youtube",
  "bi bi-zoom-in",
  "bi bi-zoom-out",
];
